
stateProviders.push({
    name: 'schoolside.vouchers',
    url: '/vouchers',
    templateUrl: 'fast/submodules/schoolside/vouchers/partials/vouchers.html?v=' + versionNo,
    controller: 'VouchersController',
    resolve: 
    {

        apple: function(VouchersModelService, authServiceFactory) {
            return VouchersModelService.get(authServiceFactory.getAuth().schoolID);
        },

        banana: function(VoucherOrderModelService, authServiceFactory) {
            return VoucherOrderModelService.get(authServiceFactory.getAuth().schoolID);
        },

        cucumber: function(VouStatementModelService, authServiceFactory) {
            return VouStatementModelService.get(authServiceFactory.getAuth().schoolID);
            // This is commented out because on the front end keeping this code causes a logout
        },
        d: function (SchoolModelService, authServiceFactory)
        {
            return SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        }

    }
});
